// @flow

import PointLayer14Resource from './PointLayer14Resource';

export type BreakConnectionPayload = {
    fiber?: string,
    port?: string,
    range?: number,
}

export default class OpticalODFPortResource extends PointLayer14Resource {
    basePath: string = 'networks/opticalodfports/';

    objectPath: string = 'networks/opticalodfports/{ident}/';

    /**
     * @param {string} id: Optical ODF Port id
     * @param {object} data: Id of the port and/or the fiber which should be disconnected
     * Example request:
     *  {
     *      fiber: 12,
     *      port: null
     *  }
     * @returns {Promise<Object>} Optical ODF Port data
     */
    breakConnection(id: string, data: BreakConnectionPayload): Promise<Object> {
        return this.client._request(
            `${this._getObjectPath(id)}break_connection/`,
            'POST', data,
        ).then((response) => response.data);
    }

    circuit(id: string, params: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}circuit/`,
            'GET',
            params,
        ).then((response) => response.data);
    }
}
